// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"6c799c58","488":"3387aec8","785":"5f5c600b"}[chunkId] + ".chunk.js";
};